import { apiFetch } from "@/lib/api";

export interface InventorySublocationMoveContext {
  quantity_at_source: number;
  unattributed_quantity: number;
}

export interface InventorySublocationMoveResult {
  from: {
    cpn: string;
    sublocation: string;
    quantity: number;
  };
  to: {
    cpn: string;
    sublocation: string;
    quantity: number;
  };
}

export async function fetchInventoryLocationChangeContext(params: {
  sku_id: string;
  from_sublocation: string;
}): Promise<InventorySublocationMoveContext> {
  const query = new URLSearchParams({
    sku_id: params.sku_id.trim(),
    from_sublocation: params.from_sublocation.trim(),
  });
  return apiFetch<InventorySublocationMoveContext>(
    `/api/manufacturing/inventory-location-change/context?${query.toString()}`,
  );
}

export async function applyInventoryLocationChange(body: {
  sku_id: string;
  from_sublocation: string;
  to_sublocation: string;
  quantity?: number;
}): Promise<{ move: InventorySublocationMoveResult }> {
  return apiFetch<{ move: InventorySublocationMoveResult }>(
    "/api/manufacturing/inventory-location-change",
    { method: "PUT", body },
  );
}
